import script from "./FormInputList.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormInputList.vue?vue&type=script&setup=true&lang=ts"

import "./FormInputList.vue?vue&type=style&index=0&id=515cbc4c&lang=css"

const __exports__ = script;

export default __exports__